import { colorSchemeKeys } from '@harvestiq/iiq-common';
import {
  isDevelopmentNodeEnv,
  getInsureIqClientPort,
  getInsureIqServerPort,
} from '@harvestiq/config';

import { defaultDbAppSettings } from '@harvestiq/iiq-common/app-settings/default-db-app-settings';
import { isLiteralObject } from './object';

const getLinkSelector = (mimeType) => `link[rel='icon'][type='${mimeType}']`;

export const updateFavicons = ({ favicon, compactLogo }, doc) => {
  if (favicon) {
    const icoLink = doc.querySelector(getLinkSelector('image/x-icon'));
    if (icoLink) {
      icoLink.href = favicon;
    }
  }
  if (compactLogo) {
    const compactLogoLink = doc.querySelector(getLinkSelector('image/*'));
    const appleIconLink = doc.querySelector("link[rel='apple-touch-icon']");
    if (compactLogoLink) {
      compactLogoLink.href = compactLogo;
    }
    if (appleIconLink) {
      appleIconLink.href = compactLogo;
    }
  }
};

/**
 * @fixme This method implementation is not intuitive and should be refactored.
 * It merges the organization application settings with the default settings.
 * We should double-check if it is really needed. If so, we should improve the implementation and type it.
 */
export const mergeOrgAppSettings = (
  settings = {},
  defaultSettings = defaultDbAppSettings
) => {
  const defaultKeys = Object.keys(defaultSettings);
  const settingsKeys = Object.keys(settings);
  const mergedKeys = [...new Set([...defaultKeys, ...settingsKeys])];
  const mergedSettings = mergedKeys.reduce(
    (acc, key) => {
      const defaultVal = defaultSettings[key];
      let val = settings[key];

      if (val === undefined || (val === '' && colorSchemeKeys.includes(key))) {
        val = defaultVal;
      }

      acc[key] =
        isLiteralObject(val) && defaultVal
          ? mergeOrgAppSettings(val, defaultVal)
          : val;

      return acc;
    },
    { ...defaultSettings }
  );

  if (typeof document !== 'undefined') {
    updateFavicons(mergedSettings, document);
  }

  return mergedSettings;
};

export const makeOrgAppSettingsId = (orgAppSettingsId) =>
  orgAppSettingsId.toLowerCase().replace(/[^\w]|_/g, '-');

export const makeOrgUrl = (domain) => {
  if (isDevelopmentNodeEnv()) {
    return `http://${domain ?? 'localhost'}:${getInsureIqClientPort()}`;
  }
  return `https://${domain}`;
};

export const makeOrgUri = (domain) => {
  if (isDevelopmentNodeEnv()) {
    return `http://${domain}:${getInsureIqServerPort()}`;
  }
  return `https://${domain}`;
};

export const makeOrgDeploymentName = (orgAppSettingsId) =>
  `portal-tenant-${orgAppSettingsId}`;
